import React from 'react'
import Kyc from "./Kyc"

export default function index() {
  return (
      <Kyc />
  )
}
